/*eslint-disable no-process-env, no-undef */
const qs = require('qs')
const { REACT_APP_API_BASE_URL } = process.env

const ENDPOINTS = {
	getLead: 'lead',
	getReport: 'reports',
	requestIntro: 'intro'
}

const reportError = (path, res, args = {}) => {
	window.mixpanel.track('[Creative Connector] - API Error', {
		baseUri: REACT_APP_API_BASE_URL,
		path,
		apiResponse: res,
		args: JSON.stringify(args)
	})
}

async function getRequest(endpoint, args = {}) {
	const path = REACT_APP_API_BASE_URL + endpoint + '?' + qs.stringify(args)
	const start = Date.now() / 1000
	try {
		const res = await fetch(path)
		if(res.status !== 200) {
			// It errored out
			reportError(path, res)
			return false
		}
		let body = await res.json()
		body.request_time = ((Date.now() / 1000) - start).toFixed(3)
		return body
	} catch(err) {
		reportError(path, {}, args)
		return false
	}
}

async function apiRequest(endpoint, args, baseUrl = REACT_APP_API_BASE_URL) {
	const start = Date.now() / 1000
	const path = baseUrl + endpoint
	try {
		const res = await fetch(path, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(args)
		})
		if(res.status !== 200) {
			reportError(path, res, args)
			// It errored out
			return false
		}
		let body = await res.json()
		body.request_time = ((Date.now() / 1000) - start).toFixed(3)
		if(body.status === 'OK') {
			return true
		} else {
			return false
		}
	} catch(err) {
		reportError(path, {}, args)
		return false
	}
}

export async function fetchLead(airtable_id) {
	const res = await getRequest(ENDPOINTS.getLead, {airtable_id})
	if(res && res.lead) { return res.lead }
	else { return false }
}

export async function fetchReport(report_id) {
	const res = await getRequest(ENDPOINTS.getReport, {report_id})
	if(res && res.vendors && res.lead) { return res }
	else { return false }
}

export async function requestIntro(resultId, vendorId) {
	const res = await apiRequest(ENDPOINTS.requestIntro, {resultId, vendorId})
	return res
}


// async function apiRequest(endpoint, args) {
// 	const start = Date.now() / 1000
// 	const path = REACT_APP_API_BASE_URL + endpoint
// 	try {
// 		const res = await fetch(path, {
// 			method: 'POST',
// 			headers: {
// 				'Content-Type': 'application/json'
// 			},
// 			body: JSON.stringify(args)
// 		})
// 		if(res.status !== 200) {
// 			reportError(path, res, args)
// 			// It errored out
// 			return false
// 		}
// 		let body = await res.json()
// 		body.request_time = ((Date.now() / 1000) - start).toFixed(3)
// 		if(body.status === 'OK') {
// 			return true
// 		} else {
// 			return false
// 		}
// 	} catch(err) {
// 		reportError(path, {}, args)
// 		return false
// 	}
// }


// WEBPACK FOOTER //
// ./src/api/index.js